import { render, staticRenderFns } from "./TiendaDetail.vue?vue&type=template&id=36922230&scoped=true&"
import script from "./TiendaDetail.vue?vue&type=script&lang=js&"
export * from "./TiendaDetail.vue?vue&type=script&lang=js&"
import style0 from "./TiendaDetail.vue?vue&type=style&index=0&id=36922230&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36922230",
  null
  
)

export default component.exports